import type { User } from '@supabase/supabase-js';

/**
 * A super admin is CODEZYAI staff running the admin console, not a customer:
 * they have no workspace and never see the customer app. The role comes from
 * the JWT's app_metadata, which only the server can set.
 */
export function isSuperAdmin(user: Pick<User, 'app_metadata'> | null | undefined): boolean {
  return user?.app_metadata?.['role'] === 'super_admin';
}
